export default {
  h1: {
    fontWeight: 500,
    fontSize: 50,
    fontFamily: " 'Mochiy Pop One', sans-serif",
    fontStyle: "normal",
    lineHeight: " 72px",
  },
  h2: {
    fontWeight: 500,
    fontSize: 30,
    fontFamily: " 'Mochiy Pop One', sans-serif",
    fontStyle: "normal",
    lineHeight: " 72px",
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    fontFamily: " 'Mochiy Pop One', sans-serif",
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    fontFamily: " 'Mochiy Pop One', sans-serif",
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
    fontFamily: " 'Mochiy Pop One', sans-serif",
    // fontStyle: "normal",
    // fontFeight: "600",
    // fontSize: "30px",
    // lineHeight: "36px",
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    fontFamily: " 'Cabin', sans-serif",
  },
  overline: {
    fontWeight: 500,
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: " 'Mochiy Pop One', sans-serif",
    fontWeight: "bold",
  },
  body1: {
    // fontSize: 12,
    fontFamily: "Cabin",
    fontStyle: "normal",
    fontFeight: "600",
    fontSize: "20px",
    fontFamily: " 'Cabin', sans-serif",
    lineHeight: "26px",
  },
  body2: {
    fontSize: 14,
    fontFamily: "Cabin",
    fontStyle: "normal",
    fontFeight: "600",
    fontFamily: " 'Cabin', sans-serif",
    fontSize: "30px",
    lineHeight: "36px",
  },
};
